export enum POLICY_TYPES {
  THANK_YOU = 'Thank You'
}
